import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';

import {
  IconComponent,
  InputComponent,
  FormFieldComponent,
  IconButtonComponent,
  DropdownHeaderComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-redactor-inserts-dropdown-header',
  templateUrl: 'redactor-inserts-dropdown-header.component.html',
  styleUrls: ['./redactor-inserts-dropdown-header.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DropdownHeaderComponent,
    IconButtonComponent,
    FormFieldComponent,
    InputComponent,
    IconComponent,
  ],
})
export class RedactorInsertsDropdownHeaderComponent {
  public readonly label = input<string>(undefined!);
  public readonly hasBackAction = input<boolean>(true);
  public readonly searchQuery = input<string>(undefined!);
  public readonly hasSearch = input<boolean>(false);
  public readonly hasSettings = input<boolean>(false);
  public readonly searchPlaceholder = input<string>(undefined!);

  public goBack = output<MouseEvent>();
  public goToSettings = output<MouseEvent>();
  public searchQueryChange = output<string>();
  public closeDropdown = output<void>();
  public focusChanges = output<boolean>();

  public onFocusChanges(value: boolean): void {
    this.focusChanges.emit(value);
  }
}
